import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './cell.vdt';
import { useConfigContext } from '../config';
export var TableCell = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TableCell, _Component);
  function TableCell() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = TableCell.prototype;
  _proto.$update = function $update(lastVNode, nextVNode, parentDom, anchor, mountedQueue, force) {
    var lastProps = lastVNode.props;
    var nextProps = nextVNode.props;
    var isSame = true;
    for (var key in lastProps) {
      if (lastProps[key] !== nextProps[key] || key === 'props' && nextProps.props.$blocks) {
        isSame = false;
        break;
      }
    }
    if (!isSame) {
      _Component.prototype.$update.call(this, lastVNode, nextVNode, parentDom, anchor, mountedQueue, force);
    }
  };
  return TableCell;
}(Component);
TableCell.template = template;